module.exports = __webpack_public_path__ + "1f89cf0eaaa1acd7bd2089464b25ad71.MP3";